import { Component } from 'macguffin'

import BackgroundImage from "utils/BackgroundImage"

const PICK_VALUE_FONT_SCALE = 0.7
const PICK_TYPE_FONT_SCALE = 0.3
const LETTER_SCALE = 0.3

const LETTERS = ["A", "B", "C", "D"]

const pickColourAssets = [
    "pickPinkNormal",
    "pickGreenNormal",
    "pickOrangeNormal",
    "pickBlueNormal"
]

const pickColourStyle = {
    backgroundPosition: "center"
}

const pickTypeAssets = [
    "pickPinkBox",
    "pickGreenBox",
    "pickOrangeBox",
    "pickBlueBox"
]

const pickTypeStyle = {
    backgroundSize: "100% 100%",
    backgroundPosition: "center"
}

export default class Pick extends Component {

    constructor() {
        super()
        this.state = {
            letterCount: -1
        }
    }

    componentWillUpdate(newProps) {
        const oldProps = this.props

        const { data } = newProps

        if (data !== oldProps.data) {
            if (data) {
                const style = !data.picked ? { filter: "grayscale(100%)" } : { transform: "scale(1.1)" }

                this.setState({ style })
            } else {
                this.setState({ style: {} })
            }
        }
    }

    renderResult = () => {
        const { props } = this
        const { index, width, height, data } = props

        const pickType = data.type
        const value = data.value
        const translation = this.t(pickType === "EXTRA_FUEL" ? "freerounds.freespins" : `freespins.picks.${pickType}`).toUpperCase()

        return [
            <h1 key="pickValue" className="pickValue" style={{fontSize: `${height * PICK_VALUE_FONT_SCALE}px`}}>
                {value}
            </h1>,

            <BackgroundImage key="pickType" className="pickType" assetName={pickTypeAssets[index]} style={pickTypeStyle}>
                <h1 style={{fontSize: `${height * PICK_TYPE_FONT_SCALE}px`}}>
                    {translation}
                </h1>
            </BackgroundImage>
        ]
    }

    render() {
        const { props, state } = this
        const { index, width, height, data, onSelect, selected, paused } = props
        const { style = {} } = state

        const onClick = () => { onSelect && onSelect(index) }

        const animationPlayState = paused ? "paused" : "running"

        let animation
        if (!data) {
            if (isNaN(selected)) {
                animation = "inviteTouch 1s infinite alternate"
            } else if (selected === index) {
                animation = "waitForServer 2s 1s infinite forwards"
            }
        }

        const size = {
            width: `${width}px`,
            height: `${height}px`
        }

        const fontSize = `${height * LETTER_SCALE}px`

        return <div className={`pick pick${index + 1}`} style={{...style, ...size}} onClick={onClick}>
            <BackgroundImage className="pickColour" assetName={pickColourAssets[index]} style={{...pickColourStyle, fontSize, animation, animationPlayState}}>
                <h1> { onSelect && LETTERS[index] }</h1>
            </BackgroundImage>
            { data && this.renderResult() }
        </div>
    }
}
